import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import campaignWeathervaneLogo from "./../../assets/img/campaign-weathervane-logo.webp";
import "./Header.scss";
import Grid from "@mui/material/Grid";
import ScoreMeter from "../ScoreMeter/ScoreMeter";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { AiOutlineInfoCircle } from "react-icons/ai";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { none } from "html-webpack-plugin/lib/chunksorter";
import { styled } from "@mui/material/styles";
import { NavLink } from "react-router-dom";

function Header(props) {
	const BootstrapTooltip = styled(({ className, ...props }) => (
		<Tooltip
			{...props}
			PopperProps={{ style: { zIndex: 1503 } }}
			placement="right"
			arrow
			classes={{ popper: className }}
		/>
	))(({ theme }) => ({
		[`& .${tooltipClasses.popper}`]: {
			justifyContent: "center",
			alignItems: "center",
		},
		[`& .${tooltipClasses.arrow}`]: {
			color: "#9FDBF4",
		},
		[`& .${tooltipClasses.tooltip}`]: {
			backgroundColor: "#9FDBF4",
			color: "#000000",
			height: "30px",
			width: "100px",
			textAlign: "center",
			padding: "10px",
			fontFamily: "Montserrat",
			fontSize: "60%",
		},
	}));

	const handleLogoClick = () => {
		const userConfirmed = window.confirm("Are you sure you want to reload the page? Reloading the page will reset your progress.")
		if (userConfirmed) {
			window.location.reload()
		}
	}

	return (
    <Box id="header" className="sticky-header">
      <Grid
        className="container"
        role="region"
        aria-label="Header"
        container
        position="relative"
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
					marginTop: 1,
        }}>
        <Grid
          item
          sm={2}
          position="relative"
          display={{ xs: "none", sm: "block" }}>
          {/* Game logo */}
          <img
            src={campaignWeathervaneLogo}
            alt={"Campaign Weathervane logo"}
            className="campaign-weathervane-logo-scroll"
            onClick={handleLogoClick}
          />
          <div className="year-text">{props.timeline}</div>
        </Grid>
        <Grid item sm={9} sx={{ flexGrow: 1 }}>
          <div className="favorability-text">
            <FaArrowLeft size={18} color="#FF0000" />
            <Box
              sx={{
                textColor: "#000000",
                fontWeight: "700",
                fontSize: "14pt",
              }}>
              Favorability
            </Box>
						<FaArrowRight size={18} color="#008000" />
          </div>
            <ScoreMeter
              percentage={Math.round(props.score)}
              responseSubmitted={props.responseSubmitted}
              scoreChange={props.scoreChange}
              textColor="#BB2292D"
            />
          <Box
            sx={{
              marginTop: 1,
              display: "flex",
              position: "relative",
              width: "100%",
            }}>
            <Box
              sx={{
                textAlign: "end",
                fontWeight: "600",
                // The width is slightly skewed to the right to account for the width of the score change text
                fontSize: "20px",
                width: `${props.score + 3}%`,
                transition: "width 0.5s ease-in-out",
              }}>
              {Math.round(props.score)}%
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          sm={1}
          sx={{ fontFamily: "Montserrat", marginBottom:1, display: "flex", flexDirection: "row", alignItems: "center", position: "relative" }}>
          <BootstrapTooltip title="What is favorability? Click to find out.">
            <IconButton aria-label="scoring info" onClick={props.onButtonClick}>
              {/* <NavLink to={"/about-scoring"} target="_blank" rel="noopener noreferrer"> */}
              <AiOutlineInfoCircle size={28} />
              {/* </NavLink> */}
            </IconButton>
          </BootstrapTooltip>
          {props.responseSubmitted ? (
            props.scoreChange >= 0 ? (
              <Box className="score-change-text green">
                +{props.scoreChange}%
              </Box>
            ) : (
              <Box className="score-change-text red">{props.scoreChange}%</Box>
            )
          ) : (
            <div></div>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
export default Header;
